import { ColumnsType } from "antd/lib/table";
import { useAppSelector } from "../../../../util/hooks";
import { DetalhesResultadoSorteioModel } from "../../../../models/resultadoSorteio/detalhesResultadoSorteioModel";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import dayjs from "dayjs";
import TableComponent from "../../../../components/table/tableComponent";

dayjs.locale("pt-br");

const HistoricoResultado = () => {
  //estados globais
  const resultadoSorteioState = useAppSelector((state) => state.resultadoSorteio);

  const columns: ColumnsType<DetalhesResultadoSorteioModel> = [
    {
      title: "DATA EMISSÃO",
      dataIndex: "dataEmissao",
      align: "center",
      sorter: (a: any, b: any) => (dayjs(b.dataEmissao).isBefore(a.dataEmissao) ? -1 : 1),
      defaultSortOrder: "descend",
      render: (_, record) => <>{dayjs(record.dataEmissao).format("DD/MM/YYYY HH:mm")}</>,
    },
    {
      title: "DATA VENCIMENTO",
      dataIndex: "dataVencimento",
      align: "center",

      sorter: (a: any, b: any) => (dayjs(b.dataVencimento).isBefore(a.dataVencimento) ? -1 : 1),
      defaultSortOrder: "descend",
      render: (_, record) => <>{dayjs(record.dataVencimento).format("DD/MM/YYYY HH:mm")}</>,
    },
    {
      title: "Nº DOCUMENTO",
      dataIndex: "tipoOperacao",
      align: "right",
    },
    {
      title: "FORNECEDOR",
      dataIndex: "razaoSocialFornecedor",
    },
    {
      title: "VALOR BRUTO",
      dataIndex: "valorBrutoConta",
      align: "right",
      sorter: (a: any, b: any) => a.valorBrutoConta - b.valorBrutoConta,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorBrutoConta),
    },
    {
      title: "VALOR RESULTADO",
      dataIndex: "valorResultadoConta",
      align: "right",
      sorter: (a: any, b: any) => a.valorResultadoConta - b.valorResultadoConta,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorResultadoConta),
    },
    {
      title: "VALOR BRUTO ATUAL",
      dataIndex: "valorBrutoAtualConta",
      align: "right",
      sorter: (a: any, b: any) => a.valorBrutoAtualConta - b.valorBrutoAtualConta,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorBrutoAtualConta),
    },
    {
      title: "VALOR RESULTADO ATUAL",
      align: "right",
      dataIndex: "valorLiquidoAtualConta",
      sorter: (a: any, b: any) => a.valorLiquidoAtualConta - b.valorLiquidoAtualConta,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorLiquidoAtualConta),
    },
    {
      title: "HISTÓRICO",
      dataIndex: "historico",
    },
  ];

  return <TableComponent data={resultadoSorteioState.detalheResultadoSorteio} columns={columns} loading={resultadoSorteioState.loadingDetalhe} />;
};

export default HistoricoResultado;
